// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
import { NgModule } from '@angular/core';
import { InvoiceStatusPipe } from './pipes/invoice-status.pipe';
import { PackageStatusPipe } from './pipes/package-status.pipe';

/**
 * Declara e exporta os pipes de status usados nos templates.
 * Diferente do módulo da lib original, não registra interceptor:
 * o header Authorization é responsabilidade do HttpAuthInterceptor
 * do próprio webapp (app/interceptor.ts).
 */
@NgModule({
  declarations: [
    InvoiceStatusPipe,
    PackageStatusPipe,
  ],
  exports: [
    InvoiceStatusPipe,
    PackageStatusPipe,
  ],
})
export class ApiModule { }
